import { AbstractModel, DateFormatConstants, DateUtil, isNullOrUndefined, LocalStorageConstants } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import moment from 'moment-timezone';
import { ChatMessage } from './chat-message';
import { DriverEarnings } from './driver-earnings';
import { ServiceLevel } from './service-level';

// Note: The properties from AbstractModel will always be null, but this object has to text AbstractDTO in CLARA to use the TripBuilder
// This will be refactored later
@inheritSerialization(AbstractModel)
export class Trip extends AbstractModel {
  @autoserializeAs(Date)
  acceptedDate: Date;

  @autoserialize
  driverCommissionEstimate: number;

  @autoserializeAs(DriverEarnings)
  driverEarnings: DriverEarnings;

  @autoserialize
  driverFareEstimate: number;

  @autoserialize
  driverName: string;

  @autoserialize
  dropoffAddress: string;

  @autoserialize
  incentive: number;

  @autoserialize
  itineraryId: number;

  @autoserialize
  journeyId: number;

  @autoserialize
  organizationId: number;

  @autoserialize
  organizationCode: string;

  @autoserialize
  pickupAddress: string;

  @autoserializeAs(Date)
  pickupDate: Date;

  @autoserialize
  providerName: string;

  @autoserialize
  reservationId: number;

  @autoserialize
  rideRequestId: number;

  @autoserialize
  riderName: string;

  @autoserialize
  rideType: string;

  @autoserialize
  status: string;

  @autoserialize
  timeZone: string;

  @autoserialize
  transitProgramCode: string;

  @autoserialize
  vehicleType: string;

  @autoserialize
  vehicleTypeCode: string;

  @autoserialize
  rideBackupEligible: boolean;

  @autoserializeAs(ServiceLevel)
  minimumServiceLevel: ServiceLevel;

  @autoserializeAs(ServiceLevel)
  executedServiceLevel: ServiceLevel;

  @autoserialize
  lyftAutoDispatchEnabled: boolean;

  chatMessages: Array<ChatMessage>;

  /**
   * TODO: We need a better way to know if a ride has chat messages
   */
  get hasNewChatMessages(): boolean {
    if (isNullOrUndefined(this.reservationId) || isNullOrUndefined(this.chatMessages)) {
      return false;
    }
    return this.chatMessages && this.chatMessages.length > this.numberOfReadChatMessages;
  }

  get numberOfReadChatMessages(): number {
    if (isNullOrUndefined(this.reservationId)) {
      return 0;
    }

    /*
     * TODO: replace object with more appropriate type.
     */
    const reservationReadChatCounts: object = JSON.parse(
      localStorage.getItem(LocalStorageConstants.LOCAL_STORAGE_KEY_RESERVATION_READ_CHAT_COUNTS)
    );

    if (isNullOrUndefined(reservationReadChatCounts)) {
      return 0;
    }

    const count: number = reservationReadChatCounts[this.reservationId.toString()];

    return isNullOrUndefined(count) ? 0 : count;
  }

  /**
   * TODO: This needs to be refactored to use RideRequestType.onDemand
   */
  get formattedDisplayDate(): string {
    if (this.rideType === 'Scheduled') {
      return moment.tz(this.pickupDate, this.timeZone).format(DateFormatConstants.DATE_FORMAT_SHORT_TIMEZONE);
    }
    return moment.tz(this.pickupDate, 'UTC').format('M/DD/YY');
  }

  static OnSerialized(instance: Trip, json: any): void {
    if (!isNullOrUndefined(instance.pickupDate)) {
      json.pickupDate = DateUtil.serializeDate(instance.pickupDate);
    }

    if (!isNullOrUndefined(instance.acceptedDate)) {
      json.acceptedDate = DateUtil.serializeInstant(instance.acceptedDate);
    }
  }

  static OnDeserialized(instance: Trip, json: any): void {
    window['instance'] = instance;
    window['instanceJSON'] = json;
    if (!isNullOrUndefined(json['pickupDate'])) {
      instance.pickupDate = DateUtil.deserializeDate(json['pickupDate']);
    }

    if (!isNullOrUndefined(json['acceptedDate'])) {
      instance.acceptedDate = DateUtil.deserializeInstant(json['acceptedDate']);
    }
  }
}
